import React from 'react'
import Layout from '../layout/Layout';

const Error404 = () => {
  return (
    <Layout>
      <h1 className='display-4 text-center text-dark bg-damger'>Error 404</h1>
    </Layout>
  )
}

export default Error404;